const { shouldShowFiltersModal } = require('../../experiments/filtersModal/util/shouldShowFiltersModal');

/**
 * Filter data shaped for the filters modal experience must not leak to other users,
 * so the builders ask this before changing anything the control group renders.
 */
const isFiltersModalExperience = ({ isBusiness, abTests, rollouts } = {}) =>
    shouldShowFiltersModal(Boolean(isBusiness), abTests || {}, rollouts || {});

module.exports = { isFiltersModalExperience };
